import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-style-four',
  templateUrl: './instructors-style-four.component.html',
  styleUrls: ['./instructors-style-four.component.scss']
})
export class InstructorsStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
